module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Excel导入请假",
      "width": "880"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.leaveParam
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.leaveParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "leaveType", $$v)
      },
      expression: "leaveParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "无需代课："
    }
  }, [_c('Select', {
    model: {
      value: (_vm.leaveParam.noProxy),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "noProxy", $$v)
      },
      expression: "leaveParam.noProxy"
    }
  }, _vm._l((_vm.$constant.yesNoNum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "说明",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.uploadLeaveUrl,
      "on-change": _vm.handleChange,
      "headers": _vm.headers,
      "on-success": _vm.handleSuccess,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "data": this.leaveParam,
      "accept": ".xls,.xlsx",
      "limit": 1,
      "multiple": false,
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传请假文件")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04dc9a1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/ExportLeaveModal.vue
// module id = 1615
// module chunks = 8